import { useEffect } from "react";
import React from "react";

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, []);

  return (
    <div class="refund-policy-container">
      <div class="refundheader">
        <h1>Returns & Refunds</h1>
        <p>Our commitment to ensuring your satisfaction with every purchase</p>
      </div>

      <div class="refundimportant-notice">
        <div class="refundimportant-notice-inner">
          <div class="refundnotice-header">
            <svg
              class="refundnotice-icon refundsvg-icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <h2 class="refundnotice-title">Important Notice</h2>
          </div>
          <p class="refundnotice-text">
            Orders once placed cannot be cancelled.
          </p>
        </div>
      </div>

      <div class="refundalternatives-section">
        <h2>Available Alternatives</h2>
        <p>
          If your goods are damaged or if you receive an incorrect product, we
          would be happy to give you the following alternatives:
        </p>
        <div class="refundalternatives-grid">
          <div class="refundalternative-card">
            <div class="refundcard-header">
              <div class="refundcard-icon-container">
                <svg
                  class="refundcard-icon refundsvg-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                  />
                </svg>
              </div>
              <h3 class="refundcard-title">Exchange</h3>
            </div>
            <p class="refundcard-content">
              Exchange the goods for an alternative of your choice to equal
              value.
            </p>
          </div>
          <div class="refundalternative-card">
            <div class="refundcard-header">
              <div class="refundcard-icon-container">
                <svg
                  class="refundcard-icon refundsvg-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 class="refundcard-title">Refund</h3>
            </div>
            <p class="refundcard-content">
              Give you a full refund for the price you paid for the goods.
            </p>
          </div>
        </div>
      </div>

      <div class="refundmain-content">
        <h2>Our Guarantee</h2>
        <div class="refundcontent-box">
          <p>
            At <a href="https://ardorbiomed.com/">Ardor Biomed</a>, every care
            is taken to ensure your order is well packed before it is
            dispatched. We take extreme measures to ensure that your order
            arrives in pristine condition. However due to the delicate nature of
            these products, in rare circumstances items can arrive damaged. We
            are unable to take responsibility for any loss or damages of
            products in transit. But we will make contact with the relevant
            courier to track your package or initiate a claim for lost products.
          </p>

          <p>
            In case of damaged products, contact must be made within 24 hours of
            receipt of the products by email{" "}
            <a href="mailto:customercare@ardorbiomed.com">
              customercare@ardorbiomed.com
            </a>{" "}
            notifying us of any damage to the product. Upon return, the article
            will undergo a quality control check to ensure the quality problem
            is found to be our responsibility rather than misuse or abuse of the
            product outside of our control. Once the returned product passes the
            quality control check to ensure it is unused and in its original
            packaging stage, an exchange/refund will be dispatched. The order
            must be returned in their original boxes, and in their original
            packaging (where possible).
          </p>
        </div>
      </div>

      <div class="refundsale-notice">
        <div class="refundsale-notice-header">
          <svg
            class="refundsale-notice-icon refundsvg-icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h2 class="refundsale-notice-title">Sale Items</h2>
        </div>
        <p class="refundsale-notice-text">
          Please note that items on sale will not be exchanged or refunded. Sale
          products are final sale only.
        </p>
      </div>

      <div class="refundsteps-section">
        <h2 class="refundsteps-title">
          <span class="refundtitle-bar"></span>
          Steps for Return Process
        </h2>

        <div class="refundtimeline-container">
          <div class="refundtimeline-line"></div>

          <div class="refundtimeline-steps">
            <div class="refundstep">
              <div class="refundstep-number">1</div>
              <div class="refundstep-content">
                <h3 class="refundstep-title">Contact Us</h3>
                <p class="refundstep-description">
                  Email{" "}
                  <a href="mailto:customercare@ardorbiomed.com">
                    customercare@ardorbiomed.com
                  </a>{" "}
                  with your{" "}
                  <span class="highlight">(Order number)_returns</span> in the
                  subject field (within 24 hours of receipt of the products).
                </p>
              </div>
            </div>

            <div class="refundstep">
              <div class="refundstep-number">2</div>
              <div class="refundstep-content">
                <h3 class="refundstep-title">Describe the Issue</h3>
                <p class="refundstep-description">
                  Describe in as much detail as possible the damage to your
                  product and attach photographic evidence detailing the damage
                  to the product.
                </p>
              </div>
            </div>

            <div class="refundstep">
              <div class="refundstep-number">3</div>
              <div class="refundstep-content">
                <h3 class="refundstep-title">Get Resolution</h3>
                <p class="refundstep-description">
                  We will contact you within 24 hours to initiate your refund or
                  send a replacement item as required.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="refundadditional-info">
        <h3>Additional Information</h3>
        <ul class="refundinfo-list">
          <li class="refundinfo-item">
            <svg
              class="refundinfo-icon refundsvg-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="info-text">
              Please note that the cost of returning the product to Ardor Biomed
              is the responsibility of the purchaser.
            </span>
          </li>
          <li class="refundinfo-item">
            <svg
              class="refundinfo-icon refundsvg-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="refundinfo-text">
              Medical and food products are not covered under the refunds and
              exchange policy.
            </span>
          </li>
        </ul>
      </div>

      <div class="refundaddress-container">
        <div class="refundaddress-inner">
          <div class="refundaddress-header">
            <svg
              class="refundaddress-icon refundsvg-icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            <h3 class="refundaddress-title">Return Delivery Address:</h3>
          </div>
          <p class="refundaddress-text">
            Unit no 9, Sakthi industrial estate, udumalpet road, Pollachi
            642003, Tamil Nadu
          </p>
        </div>
      </div>

      <div class="refundfinal-notice">
        <div class="refundfinal-notice-header">
          <svg
            class="refundfinal-notice-icon refundsvg-icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h3 class="refundfinal-notice-title">Final Notice</h3>
        </div>
        <p class="refundfinal-notice-text">
          To play it fair, we would like to advise you to choose carefully, we
          do not give refund simply because you changed your mind. Sale products
          will not be exchanged or refunded. Sale products are final sale only.
        </p>
      </div>

      <div class="refundhelp-contact">
        <p class="refundhelp-text">
          Need more help? Contact our customer support team
        </p>
        <a
          href="mailto:customercare@ardorbiomed.com"
          class="refundcontact-button"
        >
          Contact Support
        </a>
      </div>
    </div>
  );
};

export default RefundPolicy;
